const columns = [
  {
    key: "deviceCode",
    zh: "整机编号",
    en: "Device Code",
    width: "14%"
  },
  {
    key: "company",
    zh: "公司名称",
    en: "Company",
    width: "11%"
  },
  {
    key: "model",
    zh: "机型",
    en: 'Model',
    width: "7%"
  },
  {
    key: "avgPressure",
    zh: "平均压力(Mpa)",
    en: "Average Pressure(Mpa)",
    width: "10%",
    tooltip: true
  },
  {
    key: "avgTemperature",
    zh: "平均温度(℃)",
    en: "Average Temperature(℃)",
    width: "11%",
    tooltip: true
  },
  {
    key: "avgFrequency",
    zh: "平均频率(Hz)",
    en: "Average Frequency(Hz)",
    width: "10%",
    tooltip: true
  },
  {
    key: "ratedPressure",
    zh: "设定压力(Mpa)",
    en: "Rated Pressure(Mpa)",
    width: "10%",
    tooltip: true
  },
  {
    key: "upperLimitFrequency",
    zh: "上限频率(Hz)",
    en: "Upper Limit Frequency(Hz)",
    width: "10%",
    tooltip: true
  },
  {
    key: "lowerLimitFrequency",
    zh: "下限频率(Hz)",
    en: "Lower Limit Frequency(Hz)",
    width: "10%",
    tooltip: true
  },
  {
    key: "percentage",
    zh: "低频率",
    en: "Percentage",
    width: "7%",
    tooltip: true
  }
]

export default columns